<template>
    <div>
        <h6 class="font-weight-bold mb-3" >My Account</h6>
        <div class="card border-0" style="min-height: 100vh;">
            <div class="card-body" v-if="userProfile != null">
                <div class="row my-2">
                    <div class="col-lg-8 order-2">
                        <ul class="nav nav-tabs">
                            <li class="nav-item">
                                <a href="" data-target="#profile" data-toggle="tab" class="nav-link active">Profile</a>
                            </li>
                            <li class="nav-item">
                                <a href="" data-target="#edit" data-toggle="tab" class="nav-link">Edit Profile</a>
                            </li>
                            <li class="nav-item">
                                <a href="" data-target="#messages" data-toggle="tab" class="nav-link">Bank Details</a>
                            </li>
                        </ul>
                        <div class="tab-content py-4">
                            <div class="tab-pane active" id="profile">
                                <h5 class="mb-4">User Profile</h5>
                                <div class="row">
                                    <div class="col-md-6">
                                        <h6 class="small text-muted">Name</h6>
                                        <p class="h6 mb-4" v-text="`${userProfile.profile.lastname} ${userProfile.profile.firstname}`"></p>
                                        <h6 class="small text-muted">Email</h6>
                                        <p class="h6 mb-4" v-text="userProfile.email"></p>
                                    </div>
                                    <div class="col-md-6">
                                        <h6 class="small text-muted">Phone</h6>
                                        <p class="h6 mb-4">{{ userProfile.phone == null ? '---' : userProfile.phone}}</p>
                                        <h6 class="small text-muted">Username</h6>
                                        <p class="h6">{{ userProfile.username == null ? '---' : userProfile.username }}</p>
                                        <!-- <hr> -->
                                        <!-- <span class="badge badge-primary"><i class="fa fa-user"></i> 900 Followers</span>
                                        <span class="badge badge-success"><i class="fa fa-cog"></i> 43 Forks</span>
                                        <span class="badge badge-danger"><i class="fa fa-eye"></i> 245 Views</span> -->
                                    </div> 
                                    <div class="col py-4" v-if="userProfile.bank_details == null">
                                        <div class="alert alert-info">
                                            <!-- <a class="panel-close close" data-dismiss="alert">×</a>  -->
                                            Kindly update your bank details. 
                                        </div>
                                    </div>
                                    <div class="col-md-12" v-if="userProfile.bank_details != null"> 
                                        <hr>
                                        <h5 class="mb-4">Bank Details</h5>
                                    </div>
                                </div>
                                <div class="row" v-if="userProfile.bank_details != null">
                                    <div class="col-md-6">
                                        <p class="small text-muted mb-2">Bank Name</p>
                                        <h6 class="mb-4">{{ userProfile.bank_details.bank.name }}</h6>
                                    </div> 
                                    <div class="col-md-6">
                                        <p class="small text-muted mb-2">Account No</p>
                                        <p class="h6 mb-4">{{ userProfile.bank_details.account_no }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p class="small text-muted mb-2">Account Name </p>
                                        <h6 class="mb-4">{{ userProfile.bank_details.account_name }}</h6>
                                    </div> 

                                </div>
                                <!--/row-->
                            </div>
                            <div class="tab-pane" id="messages">
                                <p class="h5 mb-4">Bank Details</p>
                                <form role="form" @submit.prevent="updateBank(bank_details)" v-if="bank_details != null">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Bank Name</label>
                                        <div class="col-lg-8">
                                            <select v-model="bank_details.bank_id" class="form-control" required>
                                                <option value="" disabled>Select Bank</option>
                                                <option :value="`${bank.id}`" v-for="(bank, index) in banks" :key="index">{{ bank.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Account Name</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" v-model="bank_details.account_name" type="text" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Account Number</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" v-model="bank_details.account_no" type="number" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Account Type</label>
                                        <div class="col-lg-8">
                                            <select v-model="bank_details.account_type" class="form-control" required>
                                                <option value="" disabled>Pick Account Type</option>
                                                <option value="savings">Savings</option>
                                                <option value="current">Current</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label"></label>
                                        <div class="col-lg-8 d-flex mt-3">
                                            <div class="d-none d-md-block ml-auto">
                                                <button type="submit" class="btn btn-custom ml-auto">Save</button>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="d-md-none d-sm-block">
                                                <button type="submit" class="btn btn-custom btn-block">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                <form role="form" @submit.prevent="saveBank()" v-else>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Bank Name</label>
                                        <div class="col-lg-8">
                                            <select v-model="bank_form.bank_id" class="form-control" required>
                                                <option value="" disabled>Select Bank</option>
                                                <option :value="`${bank.id}`" v-for="(bank, index) in banks" :key="index">{{ bank.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Account Name</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" v-model="bank_form.account_name" type="text" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Account Number</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" v-model="bank_form.account_number" type="number" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Account Type</label>
                                        <div class="col-lg-8">
                                            <select v-model="bank_form.account_type" class="form-control" required>
                                                <option value="" disabled>Pick Account Type</option>
                                                <option value="savings">Savings</option>
                                                <option value="current">Current</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label"></label>
                                        <div class="col-lg-8 d-flex mt-3">
                                            <div class="d-none d-md-block ml-auto">
                                                <button type="submit" class="btn btn-custom ml-auto">Save</button>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="d-md-none d-sm-block">
                                                <button type="submit" class="btn btn-custom btn-block">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                            <div class="tab-pane" id="edit">
                                <form role="form" @submit.prevent="updateProfile(userProfile)">
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">First name</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" type="text" v-model="userProfile.profile.firstname" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Last name</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" v-model="userProfile.profile.lastname" type="text" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Email</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" type="email" v-model="userProfile.email" readonly>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Username</label>
                                        <div class="col-lg-8">
                                            <input class="form-control" type="text" v-model="userProfile.username" required>
                                        </div>
                                    </div>
                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label">Phone Number</label>
                                        <div class="col-lg-8">
                                            <vue-tel-input @country-changed="getCountry($event)" v-model="userProfile.phone" v-bind="bindProps"></vue-tel-input>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-lg-3 col-form-label form-control-label"></label>
                                        <div class="col-lg-8 d-flex mt-3">
                                            <div class="d-none d-md-block ml-auto">
                                                <input type="submit" class="btn btn-custom ml-auto" value="Save Changes">
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="d-md-none d-sm-block">
                                                <input type="submit" class="btn btn-custom btn-block" value="Save Changes">
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 order-1 text-center">
                        <img src="@/assets/avatar-purple.png" class="mx-auto img-fluid rounded-circle d-block" alt="avatar" style="height:100px;">
                        <h6 class="mt-3">Upload a photo</h6>
                        <!-- <label class="custom-file">
                            <input type="file" id="file" class="custom-file-input">
                            <span class="btn btn-link">Choose file</span>
                        </label> -->
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data() {
        return {
            banks: null,
            bank_form: {
                account_name: '',
                account_number: '',
                bank_id: '',
                account_type: ''
            },
            form: {
                phone: '',
                country: '',
                dialCode: ''
            },
            bindProps: {
                defaultCountry: "NG",
                disabledFetchingCountry: false,
                disabled: false,
                disabledFormatting: false,
                placeholder: "Enter a phone number",
                required: true,
                enabledCountryCode: true,
                enabledFlags: true,
                preferredCountries: ["AU", "BR"],
                onlyCountries: [],
                ignoredCountries: [],
                autocomplete: "off",
                name: "telephone",
                maxLen: 25,
                wrapperClasses: "",
                inputClasses: "",
                dropdownOptions: {
                    disabledDialCode: false
                },
                inputOptions: {
                    showDialCode: false
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'userProfile'
        ]),

        bank_details() {
            return this.userProfile.bank_details
        }
    },
    created() {
        this.$store.dispatch('getUserProfile')
        this.getBanks();
    },
    methods: {
        getCountry($event) {
            this.form.country = $event.iso2;
            this.form.dialCode = $event.dialCode;
        },
        updateProfile(profile) {
            const data = {
                firstname: this.userProfile.profile.firstname,
                lastname: this.userProfile.profile.lastname,
                username: this.userProfile.username,
                phone: this.userProfile.phone,
                country: this.form.country
            };

            this.$store.dispatch('updateProfile', data).then((response) => {
                if (response.status == 200) {
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Profile Updated successfully'
                    });
                }

                this.$store.dispatch('getUserProfile');
            });
        },

        getBanks: async function() {
            try {
                const banks = await axios.post('/banks');

                if (banks.status == 200 && banks.data.status == 'ok') {
                    this.banks = banks.data.message;
                }
            } catch (error) {
                console.log(error.response);
            }
        },
        async saveBank() {

            console.log(this.bank_form)
            try {
                const bank = await axios.post('/auth/me/update', this.bank_form);
                console.log(bank)

                if (bank.status == 200) {
                    
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Bank details has been updated successfully'
                    });

                    this.$store.dispatch('getUserProfile');
                }

            } catch (error) {
            }
        },
        updateBank: async function(bank_details) {

            const bank_form = {
                account_name: bank_details.account_name,
                account_number: bank_details.account_no,
                bank_id: bank_details.bank_id,
                account_type: bank_details.account_type
            };

            console.log(bank_form)
            try {
                const bank = await axios.post('/auth/me/update', bank_form);
                console.log(bank)

                if (bank.status == 200) {
                    
                    this.$notify({
                        group: 'foo',
                        type: 'success',
                        title: 'Success',
                        text: 'Bank details has been updated successfully'
                    });

                    this.$store.dispatch('getUserProfile');
                }

            } catch (error) {
                // console.log(error.response)
            }
        }
    }
}
</script>

<style>

</style>